module.exports = "/src/views/player/help/images/gazon2.jpg";